<template>
  <div>
    <div class="shadow" @click="shadowClicked" ref="shadow">
      <div class="modal">
        <div class="title">{{ title }}</div>
        <div class="content"><slot></slot></div>
        <div class="actions">
          <button v-if='ok' @click="$emit('ok')">{{ ok }}</button>
          <button class='grey' v-if='cancel' @click="$emit('cancel')">{{ cancel }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Modal',
  props: ['title', 'ok', 'cancel'],
  methods: {
    shadowClicked ($e) {
      if($e.target === this.$refs.shadow) this.$emit('cancel');
    }
  }
}
</script>
<style lang="scss" scoped>
  .shadow {
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0; 
    left: 0;
    width: 100vw;
    height: 100vh;

    .modal {
      width: 50vw;
      background: #393C44;
      border: 1px solid #454A55;
      border-radius: 5px;
      padding: 15px 20px;
      margin: 30vh auto auto auto;

      .title {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
        user-select: none;
      }

      .actions {
        margin-top: 20px;

        button {
          margin-right: 10px;
        }
      }
    }
  }
</style>
